module.exports = {"id":"138782","name":"Darren Fletcher","rating":"75","photo":"./data/images/photos/0/138782.png","club":{"name":"Stoke City","logo":"./data/images/clubs/StokeCity.png"},"positions":["MC","MDC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DarrenFletcher0.json
// module id = 980
// module chunks = 0